/** Whether a keyboard event's target is a text-entry element (input/textarea/contenteditable) —
 *  shared by the held-space pan guard and the Delete/Backspace annotation-erase guard
 *  so a keystroke typed into a text field (a room rename, the chat composer, …) is never swallowed
 *  as a stage shortcut. */
export function isTextTarget(t: EventTarget | null): boolean {
  const el = t as HTMLElement | null;
  return !!el && (el.tagName === "INPUT" || el.tagName === "TEXTAREA" || el.isContentEditable);
}
